import PropTypes from "prop-types";

const ModelEnum = Object.freeze({
  HCF: "HCF",
  HCP: "HCP",
});

const RequirementType = PropTypes.shape({
  requirement: PropTypes.shape({
    _id: PropTypes.string.isRequired,
    name: PropTypes.string.isRequired,
  }).isRequired,
  expires: PropTypes.instanceOf(Date),
});

export { ModelEnum, RequirementType };
